module.exports = __webpack_public_path__ + "img/face-disappointed.5a4fd968.svg";